import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2273196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "GroundWork" }
const _hoisted_2 = { id: "section1" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"ProgressFld\" data-v-c2273196><div class=\"progBar\" data-v-c2273196><p class=\"bar\" data-v-c2273196></p></div></div><div class=\"QuestionFld\" data-v-c2273196><div class=\"QuestionText\" data-v-c2273196>この中で最も重視する<br data-v-c2273196>ポイントを教えてください</div></div>", 2)
const _hoisted_5 = { class: "AnserFld" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["Topics", {Yellow: _ctx.isYellow1, Gray: _ctx.isGray1}]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.isactive1 && _ctx.isactive1(...args)))
        }, "給与・報酬が高い", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Topics", {Yellow: _ctx.isYellow2, Gray: _ctx.isGray2}]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.isactive2 && _ctx.isactive2(...args)))
        }, "時間の融通が利く", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Topics", {Yellow: _ctx.isYellow3, Gray: _ctx.isGray3}]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.isactive3 && _ctx.isactive3(...args)))
        }, "在宅・リモートOK", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Topics", {Yellow: _ctx.isYellow4, Gray: _ctx.isGray4}]),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.isactive4 && _ctx.isactive4(...args)))
        }, "短期でもOK", 2)
      ])
    ])
  ]))
}